// Serializacja zastosowanych filtrów do/z query param `f`.
// Dzięki temu po wejściu w produkt i powrocie (history back) URL listy — a więc
// filtry — są odtwarzane. Sortowanie i strona są trzymane osobno (page, order_by).

export const encodeFilters = (filters) => {
  if (!filters) return null
  // Jeśli poza `available_only` nie ma żadnych kluczy — traktujemy jako stan domyślny
  // i nie zapisujemy parametru (czysty URL, potrzebne przy resecie).
  const keys = Object.keys(filters).filter((k) => k !== 'available_only')
  if (keys.length === 0) return null
  try {
    return encodeURIComponent(JSON.stringify(filters))
  } catch (e) {
    return null
  }
}

export const decodeFilters = (raw) => {
  if (!raw) return null
  try {
    const obj = JSON.parse(decodeURIComponent(raw))
    return obj && typeof obj === 'object' && !Array.isArray(obj) ? obj : null
  } catch (e) {
    return null
  }
}
